import React, { useMemo, useState, useEffect } from 'react';
import { buildQuery } from './utils';
import { BreakpointsContext } from './BreakpointsContext';
export const BreakpointsProvider = props => {
  const {
    breakpoints,
    children
  } = props;
  const breakpointKeys = useMemo(() => Object.keys(breakpoints).sort((keyA, keyB) => breakpoints[keyA] - breakpoints[keyB]), [breakpoints]);
  const breakpointIndexes = useMemo(() => breakpointKeys.reduce((acc, key, index) => {
    acc[key] = index;
    return acc;
  }, {}), [breakpointKeys]);
  const defaultBreakpoint = props.defaultBreakpoint || breakpointKeys[0];
  const [matchedIndex, setMatchedIndex] = useState(breakpointIndexes[defaultBreakpoint]);
  useEffect(() => {
    const queryLists = [];
    for (let i = breakpointKeys.length - 1; i >= 0; i--) {
      const fromKey = breakpointKeys[i];
      const toKey = breakpointKeys[i + 1];
      const fromValue = breakpoints[fromKey];
      const toValue = breakpoints[toKey];
      const query = buildQuery(fromValue, toValue);
      const queryList = window.matchMedia(query);
      const updateMatchedIndex = () => {
        if (queryList.matches) {
          setMatchedIndex(i);
        }
      };
      queryList.onchange = updateMatchedIndex;
      updateMatchedIndex();
      queryLists.push(queryList);
    }
    return () => {
      queryLists.forEach(queryList => {
        // eslint-disable-next-line no-param-reassign
        queryList.onchange = null;
      });
    };
  }, [breakpoints, breakpointKeys]);
  const contextValue = useMemo(() => {
    const match = value => {
      let maxMatchedIndex = 0;
      for (const key in value) {
        const index = breakpointIndexes[key];
        if (index <= matchedIndex && index > maxMatchedIndex) {
          maxMatchedIndex = index;
        }
      }
      return value[breakpointKeys[maxMatchedIndex]];
    };
    return {
      match
    };
  }, [matchedIndex, breakpointKeys, breakpointIndexes]);
  return /*#__PURE__*/React.createElement(BreakpointsContext.Provider, {
    value: contextValue
  }, children);
};